module.exports = __webpack_public_path__ + "de77a722/img/upload-icon.9179ae4e.svg";